import React, { useEffect, useState, useRef } from 'react';
import api from './utils/DoRequest';
import * as apiUrl from './constants';
import { connect } from 'react-redux';
import { ACTION_USERINFO, CHANGE_TOKEN_PHONE, ACTION_LAWYER_USERINFO, ACTION_AVATAR } from './actions/home';
import { withRouter } from 'react-router-dom';
import { LEGAL, LAWYER } from './dictionaries';
import { Button } from 'antd-mobile';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import url from 'url';
import * as imActions from './components/IMPlatform/actions/actions';
import * as ImActions from './actions/im';
import { actions } from './components/IMPlatform';
import { Toast } from 'antd-mobile';
function App(props) {
    // var req = new XMLHttpRequest();
    // // req.open('GET', document.location, false);
    // // req.send(null);
    // var headers = req.getAllResponseHeaders().toLowerCase();
    // // alert(headers);
    // Toast.fail(headers);

    const [userNotExist, setUserNotExist] = useState(false);
    const [userInfo, setUserInfo] = useState(false);
    const phoneInput = useRef(null);
    const httpUrl = props.location.search;
    const pathname = props.location.pathname;
    const _phone = url.parse(httpUrl, true).query.phone;
    const appVersion = url.parse(httpUrl, true).query.appVersion;
    const source = url.parse(httpUrl, true).query.source; // 来源
    const hanukkahUserId = url.parse(httpUrl, true).query.hanukkahUserId;
    const _email = url.parse(httpUrl, true).query.email;

    const phone = _phone === 'null' ? null : _phone;
    const email = _email === 'null' ? null : _email;

    const {
        getPhoneToken: { token },
        getUserInfo,
        changeToken,
        getLawUserInfo,
    } = props;

    useEffect(() => {
        if (
            pathname === '/credentials' &&
            source &&
            (Number(source) === 0 || Number(source) === 2 || Number(source) === 3)
        ) {
            setUserInfo(true);
            let pathnameChange = '/credentialsCase';
            // props.history.push(pathnameChange + `?userId=${userId}`);
            console.log(props.location.search, 'props.location.search');
            props.history.push(pathnameChange + props.location.search);
        } else {
            // let phone = 13026321002; // 仅开发用
            if (phone || email) {
                registerAir(phone ? phone : email);
            } else {
                if (
                    pathname === '/userAgreement' ||
                    pathname === '/website' ||
                    pathname === '/examine' ||
                    pathname === '/studyList' ||
                    pathname === '/honorDetail' ||
                    pathname === '/cooperlist' ||
                    pathname === '/lawyerCase' ||
                    pathname === '/card'
                ) {
                    if (pathname === '/card') {
                        const httpUrl = props.location.search;
                        const userId = url.parse(httpUrl, true).query.userId;
                        if (userId) {
                            handleGetUserTokenByUserId(userId);
                        }
                    } else {
                        setUserInfo(true);
                        props.history.push(pathname + props.location.search);
                    }
                } else {
                    setUserInfo(false);
                }

                console.error('token或phone不存在，请检查', token, phone);
            }
        }
    }, []);

    const registerAir = async identifier => {
        // const res = await api.doGETRequest(apiUrl.GET_USERINFO_BY_AIR + `?phoneNum=${phone}`);
        const res = await api.doGETRequest(apiUrl.GET_USERINFO_BY_AIR + `?identifier=${identifier}`);

        if (res.result && res.result.code === 0) {
            handlegetUserInfo({ phone: phone, email: email });
        } else {
            // setUserNotExist(true)
            window.location.href = '/website?type=1';
            // handleSkip('/website?type=1');
        }
    };

    const getNotice = num => {
        props.getNumNotice(num);
    };

    /**
     * 获取用户基本信息
     // * @param phone string || number 用户手机号
     * @param _data Object {phone:用户手机号,hanukkahUserId:用户hanukkahUserId}
     * @returns {Promise<void>}
     */
    const handlegetUserInfo = async _data => {
        const phone = _data.phone;
        const email = _data.email;
        const { initializeIM } = props;
        // const res = await api.doPOSTRequest(apiUrl.PLATFROM_CHECK, { phoneNumber: phone });
        // 添加identifier字段，phoneNum字段暂不删除（app升级时间容错）
        // const res = await api.doPOSTRequest(apiUrl.PLATFROM_CHECK, {
        //     phoneNumber: phone,
        //     identifier: hanukkahUserId,
        // });
        const res = await api.doPOSTRequest(apiUrl.PLATFROM_CHECK, {
            phoneNumber: phone,
            identifier: phone ? phone : email,
        });
        if (res.result.code === 0) {
            const { accountType, isValid, token, hanukkahUserId, userName, userPhotoUrl, email } = res.data;

            // accountType: 0
            // auditStatus: 1
            // authPost: null
            // changePassword: 0
            // companyId: 100138
            // companyName: "测试修改顶级组织名称"
            // content: "律师用户验证成功"
            // email: "wumufei@wusongtech.com"
            // errorCode: null
            // groupCompanyId: 100138
            // groupCompanyName: "测试修改顶级组织名称"
            // hanukkahUserId: "f69a12bd-bc3c-4639-aa3f-bcfc4b4a02d0"
            // isSuccess: true
            // isValid: true
            // lawfirm: "测试修改顶级组织名称"
            // licence: null
            // mobile: "18888000088"
            // permission: false
            // position: "合伙人"
            // privilege: 0
            // roleId: null
            // ssoIdentifier: null
            // ssoPersistenceId: null
            // ssoUserId: null
            // token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ7XCJsZW9Vc2VyXCI6e1wiYWNjb3VudFR5cGVcIjowLFwiYXVkaWVuY2VUeXBlXCI6XCJ3ZWJcIixcImF1ZGl0U3RhdHVzXCI6XCIxXCIsXCJjb21wYW55SWRcIjpcIjEwMDEzOFwiLFwiZW1haWxcIjpcInd1bXVmZWlAd3Vzb25ndGVjaC5jb21cIixcImdyb3VwQ29tcGFueUlkXCI6XCIxMDAxMzhcIixcImhhbnVra2FoVXNlcklkXCI6XCJmNjlhMTJiZC1iYzNjLTQ2MzktYWEzZi1iY2ZjNGI0YTAyZDBcIixcImlkXCI6MTAwMjIyLFwibGFzdE1vZGlmeVRpbWVcIjpcIjIwMjAtMDUtMTkgMjA6MDY6MjEuMFwiLFwibmFtZVwiOlwi5q-b5q-b6JmrXCIsXCJuZWVkQ2hlY2tcIjpmYWxzZSxcIm5lZWRTbGlwcGVyUGljXCI6ZmFsc2UsXCJwaG9uZU51bWJlclwiOlwiMTg4ODgwMDAwODhcIixcInBpY1VybFwiOlwiaHR0cHM6Ly90Zy10aWFudG9uZy10ZXN0Lm9zcy1jbi1iZWlqaW5nLmFsaXl1bmNzLmNvbS9oZWFkcGljLzA2MWMwNzQ2ODRmNTQxNzJiNjVkMDg0ZDFhMDY2NDIzLmpwZ1wiLFwicHJpdmlsZWdlXCI6XCIwXCIsXCJyZWdpc3RlckRhdGVcIjoxNTY1NzQ4OTU5MDAwLFwic3RhdHVzXCI6MSxcInVzZXJuYW1lXCI6XCIxODg4ODAwMDA4OFwifSxcInVzZXJuYW1lXCI6XCIxODg4ODAwMDA4OFwifSIsInVJZCI6MTAwMjIyLCJhdWRpZW5jZSI6IndlYiIsImNyZWF0ZWQiOjE1OTg5MzE2NTM4MzMsImV4cCI6MTYwNDkzMTY1M30.aF02zYXOhOkSvu0nRTgA37m_bNIJ0e05FHhhq6FrWICkC4T5wpA9ggYFcqLlHFh5ubR7EJILy03zDpwIFSIQ3w"
            // userId: "100222"
            // userName: "毛毛虫"
            // userPhotoUrl: "https://tg-t

            // 更改redux里面userInfo信息
            getUserInfo(res.data);
            // 更改redux getPhoneToken里面的phone和token app版本号
            changeToken(phone, token, appVersion, hanukkahUserId, email);
            // 初始化IM聊天
            initializeIM &&
                initializeIM({
                    icon: userPhotoUrl,
                    userId: hanukkahUserId,
                    pid: hanukkahUserId,
                    userName,
                });
            props.setNotificationCallback(getNotice);
            props.setSwitchSessionCallback(null);
            if (isValid) {
                switch (accountType) {
                    // 律师---> 获取律师的进本信息
                    case LAWYER:
                        // const lawyerRes = await api.doGETRequest(
                        //     `${apiUrl.GET_CALLING_CARD_DETAIL}?userId=${hanukkahUserId}`
                        // );
                        // if (lawyerRes.code === 200) {
                        //     // 增加redux userInfo里面的律师信息lawyerInfo
                        //     getLawUserInfo({ lawyerInfo: lawyerRes.data });
                        //     handleSkip('/calendar', LAWYER);
                        // }

                        getLawUserInfo({ lawyerInfo: {} });
                        handleSkip('/calendar', LAWYER);
                        break;
                    case LEGAL:
                        handleSkip('/homePage');
                        break;
                    default:
                        handleSkip('/homePage');
                }
            } else {
                handleSkip('/pastDue');
            }
        } else if (res.result.code === 90003) {
            // handleSkip('/website?type=1');
            window.location.href = '/website?type=1';
        } else {
            window.location.href = 'clickback:navigation';
            console.error('获取用户信息失败');
        }
    };

    const handleGetUserTokenByUserId = async userId => {
        const res = await api.doGETRequest(apiUrl.GET_LAWYER_CASE_TOKEN + `?userId=${userId}`);
        if (res.result && res.result.code === 0) {
            const token = res.data.token;
            console.log(res.data, 'data1111');
            getUserInfo({ token, appVersion });

            setUserInfo(true);
        } else {
            window.location.href = '/website?type=1';
            // handleSkip('/website?type=1');
        }
    };

    /**
     * 跳转页面的方法
     * @param path  跳转的路径
     * @param userType  跳转的参数
     */
    const handleSkip = (path, userType) => {
        setUserInfo(true);
        if (pathname !== '/') {
            props.history.replace(pathname + props.location.search);
        } else {
            props.history.replace({
                pathname: path,
                state: userType
                    ? {
                          type: userType,
                      }
                    : undefined,
            });
        }
    };

    /**
     * 获取登录手机号 进行登录
     */
    const handleLogin = () => {
        handlegetUserInfo(phoneInput.current.value);
    };

    return (
        <div className="logoin_change">
            {userNotExist ? (
                <div style={{ 'text-align': 'center', margin: '30px 0' }}>本功能只对天工用户开放</div>
            ) : userInfo ? (
                <div className="app" id="app">
                    {props.children}
                </div>
            ) : (
                // 开发时可以打开登录
                <div style={{ display: 'none' }}>
                    <Input type="text" ref={phoneInput} name="phone" placeholder="请输入手机号" />
                    <Button onClick={handleLogin} type="primary">
                        登录
                    </Button>
                </div>
            )}
        </div>
    );
}

const Input = styled.input`
    width: 100%;
    border: 1px solid #2d80f1;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
`;

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            getUserInfo: userInfo => ({ type: ACTION_USERINFO, userInfo }),
            changeToken: (phone, token, appVersion, hanukkahUserId, email) => ({
                type: CHANGE_TOKEN_PHONE,
                phone,
                token,
                appVersion,
                hanukkahUserId,
                email,
            }),
            getLawUserInfo: lawyerInfo => ({ type: ACTION_LAWYER_USERINFO, lawyerInfo }),
            initializeIM: imActions.initializeIM,
            externalInit: actions.externalInit,
            setNotificationCallback: actions.setNotificationCallback,
            setSwitchSessionCallback: actions.setSwitchSessionCallback,
            getNumNotice: ImActions.getNumNotice,
        },
        dispatch
    );
};

export default connect(state => {
    return state;
}, mapDispatchToProps)(withRouter(App));
